<form
  class="easy-form"
  [formGroup]="form"
  appScrollToInvalidControl
  [class.admin-mode]="isAdminMode"
  [appEditableWithRole]="['PRODUCT_ADMIN', 'EASYLOT_ADMIN']"
>
  <ng-container *ngIf="(isLoading$ | async) === false">
    <!-- templates -->
    <ng-template let-control="control" let-title="title" #boolField>
      <mat-form-field>
        <app-easy-checkbox
          [formControlName]="control"
          [label]="TITLE + title | translate"
        ></app-easy-checkbox>
      </mat-form-field>
    </ng-template>

    <!-- productMainCategory -->

    <mat-form-field *ngIf="!'HIDDEN UNTIL FURTHER NOTICE'" class="w-100">
      <app-easy-select
        [label]="TITLE + 'MAIN_CATEGORY' | translate"
        formControlName="productMainCategory"
        [options]="
          productMainCategories | toSelectOption: 'PRODUCTS.MAIN_CATEGORY.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [translatePrefixForSelected]="'PRODUCTS.MAIN_CATEGORY.'"
        [differentLabelWhenSelected]="true"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>

    <fieldset class="in-two-columns w-100">
      <legend>{{ TITLE + "PRODUCT_DATA" | translate }}:</legend>

      <mat-form-field>
        <app-easy-input [label]="TITLE + 'BRAND'" formControlName="brand">
        </app-easy-input>
      </mat-form-field>

      <mat-form-field>
        <app-easy-input [label]="TITLE + 'NAME'" formControlName="name">
        </app-easy-input>
      </mat-form-field>
    </fieldset>

    <div
      *ngFor="
        let eanGroup of getArrayCtrl('eanCodes')?.controls;
        let idx = index
      "
      class="in-two-columns"
      [formGroup]="asGroup(eanGroup)"
    >
      <mat-form-field>
        <app-easy-input [label]="TITLE + 'EAN'" formControlName="ean">
        </app-easy-input>
      </mat-form-field>
      <div class="ean-btns d-flex">
        <button
          *ngIf="devMode && !readOnly"
          class="align-self-start me-3"
          mat-stroked-button
          color="primary"
          type="button"
          (click)="generateRandomLengthNumber(13, 'eanCodes', idx)"
        >
          Generate EAN
        </button>
        <button
          *ngIf="!readOnly"
          type="button"
          mat-icon-button
          (click)="removeEanField(idx)"
        >
          <mat-icon> delete_forever</mat-icon>
        </button>
      </div>
    </div>

    <div class="in-two-columns">
      <button
        *ngIf="!readOnly"
        mat-stroked-button
        color="primary"
        type="button"
        (click)="addEanField()"
      >
        Új EAN hozzáadása
      </button>
    </div>

    <div class="in-one-column w-100">
      <!-- netAmount number & unit select -->

      <app-packaging-unit
        *ngIf="getCtrl('rootPackagingUnit')"
        [form]="getGroupCtrl('rootPackagingUnit')"
        [TITLE]="TITLE"
        [readOnly]="readOnly"
      ></app-packaging-unit>

      <app-packaging-unit
        [form]="getGroupCtrl('packagingUnit')"
        [TITLE]="TITLE"
        [readOnly]="readOnly"
      ></app-packaging-unit>

      <fieldset class="w-100 in-two-columns">
        <legend>{{ TITLE + "DRINK_PROPERTIES" | translate }}:</legend>

        <mat-form-field>
          <app-easy-select-expandable
            [label]="TITLE + 'DRINK_TYPE' | translate"
            formControlName="drinkType"
            [options]="drinkTypes"
            [labelAttribute]="'name'"
            [groupLabelAttribute]="'groupName'"
            [groupOptionsAttribute]="'options'"
            [valueAttribute]="'value'"
            (ngModelChange)="drinkTypeChanged($event)"
          ></app-easy-select-expandable>
        </mat-form-field>

        <ng-container
          *ngIf="getCtrl('alcoholicDrinkProperties')"
          formGroupName="alcoholicDrinkProperties"
        >
          <mat-form-field>
            <app-easy-input
              [label]="TITLE + 'ALCOHOL_LEVEL' | translate"
              formControlName="alcoholLevel"
              type="number"
              step="1"
              min="0"
              max="100"
            >
            </app-easy-input>
          </mat-form-field>
        </ng-container>

        <!-- alcoholFree -->

        <ng-container
          *ngIf="getCtrl('alcoholicDrinkProperties.alcoholFree')"
          formGroupName="alcoholicDrinkProperties"
        >
          <mat-form-field>
            <app-easy-checkbox
              class="alcohol-free-checkbox"
              formControlName="alcoholFree"
              [label]="TITLE + 'ALCOHOL_FREE' | translate"
              (ngModelChange)="onAlcoholFreeChanged($event)"
            ></app-easy-checkbox>
          </mat-form-field>
        </ng-container>
      </fieldset>

      <!-- alcoholicDrinkProperties subform -->

      <app-alcoholic-drink-properties-subform
        *ngIf="getCtrl('alcoholicDrinkProperties')"
        groupName="alcoholicDrinkProperties"
      ></app-alcoholic-drink-properties-subform>

      <!-- nonAlcoholicDrinkProperties subform -->

      <app-non-alcoholic-drink-properties-subform
        *ngIf="getCtrl('nonAlcoholicDrinkProperties')"
        groupName="nonAlcoholicDrinkProperties"
      ></app-non-alcoholic-drink-properties-subform>
    </div>

    <fieldset class="w-50">
      <legend>{{ TITLE + "OTHER" | translate }}:</legend>

      <div class="in-one-left-column">
        <!-- vatRate select -->

        <mat-form-field>
          <app-easy-select
            formControlName="vatRate"
            [label]="TITLE + 'VAT_RATE' | translate"
            [translatePrefixForSelected]="'PRODUCTS.VAT_RATE.'"
            [labelAttribute]="'name'"
            [valueAttribute]="'value'"
            [hasEmptyOption]="false"
            [options]="vatRates | toSelectOption: 'PRODUCTS.VAT_RATE.'"
          >
          </app-easy-select>
        </mat-form-field>

        <ng-container
          *ngTemplateOutlet="
            boolField;
            context: {
              control: 'equalizedAmount',
              title: 'EQUALIZED_AMOUNT'
            }
          "
        ></ng-container>

        <mat-form-field>
          <app-easy-input
            formControlName="grossWeightInKilograms"
            [label]="TITLE + 'GROSS_WEIGHT_IN_KILOGRAMS' | translate"
            type="number"
            min="0"
          >
          </app-easy-input>
        </mat-form-field>

        <ng-container
          *ngTemplateOutlet="
            boolField;
            context: {
              control: 'packagingFreeProduct',
              title: 'PACKAGING_FREE_PRODUCT'
            }
          "
        ></ng-container>

        <mat-form-field *ngIf="getCtrl('placeOfOrigin')">
          <app-easy-select
            formControlName="placeOfOrigin"
            [label]="TITLE + 'PLACE_OF_ORIGIN' | translate"
            [translatePrefixForSelected]="'COUNTRY.'"
            [labelAttribute]="'name'"
            [valueAttribute]="'value'"
            [hasEmptyOption]="false"
            [options]="countries | toSelectOption: 'COUNTRY.'"
          >
          </app-easy-select>
        </mat-form-field>
      </div>
    </fieldset>

    <div class="w-100 in-two-columns">
      <mat-form-field>
        <app-easy-input
          formControlName="knCode"
          [label]="TITLE + 'KN_CODE' | translate"
        >
        </app-easy-input>
      </mat-form-field>

      <button
        *ngIf="devMode && !readOnly"
        mat-stroked-button
        color="primary"
        type="button"
        class="generate-btn"
        (click)="generateRandomLengthNumber(8, 'knCode')"
      >
        Generate KN kód
      </button>
    </div>

    <ng-template
      let-control="control"
      let-title="title"
      let-rows="rows"
      #localizedTextArea
    >
      <app-easy-localized-value-subform
        class="w-100"
        [formGroupAbstract]="form.get(control)!"
        [title]="TITLE + title"
        [textareaAutosizeMinRows]="rows"
        [readOnly]="readOnly"
      ></app-easy-localized-value-subform>
    </ng-template>

    <!-- allergenic subform -->

    <app-product-allergenic-subform
      groupName="allergenic"
    ></app-product-allergenic-subform>

    <!-- customerSegment subform -->

    <fieldset *ngIf="!isSecondaryProductSheet">
      <legend class="required">
        {{ TITLE + "CUSTOMER_SEGMENT" | translate }}:
      </legend>
      <mat-form-field>
        <app-easy-select-expandable
          label=""
          formControlName="customerSegmentSelector"
          [options]="customerSegments"
          [disabledMatTooltip]="'PRODUCTS.HINT.CUSTOMER_SEGMENT_CHANGE'"
          [labelAttribute]="'name'"
          [groupLabelAttribute]="'groupName'"
          [groupOptionsAttribute]="'options'"
          [valueAttribute]="'value'"
          [multiple]="true"
          [hideRequiredLabel]="true"
          (ngModelChange)="valueChanged($event)"
        ></app-easy-select-expandable>
      </mat-form-field>
    </fieldset>

    <mat-form-field *ngIf="getCtrl('videoLink')" class="w-100">
      <app-easy-input
        formControlName="videoLink"
        [label]="TITLE + 'VIDEO_LINK' | translate"
      >
      </app-easy-input>
    </mat-form-field>

    <ng-container
      *ngTemplateOutlet="
        localizedTextArea;
        context: { control: 'shortDescription', title: 'SHORT_DESCRIPTION' }
      "
    ></ng-container>

    <ng-container *ngIf="getCtrl('detailedDescription')">
      <ng-container
        *ngTemplateOutlet="
          localizedTextArea;
          context: {
            control: 'detailedDescription',
            title: 'DETAILED_DESCRIPTION',
            rows: 3
          }
        "
      ></ng-container>
    </ng-container>

    <mat-form-field *ngIf="getCtrl('descriptionOfUsage')">
      <app-easy-textarea
        formControlName="descriptionOfUsage"
        [label]="TITLE + 'DESCRIPTION_OF_USAGE' | translate"
        [rows]="3"
        [resizable]="false"
      ></app-easy-textarea>
    </mat-form-field>

    <mat-form-field *ngIf="getCtrl('descriptionOfStorage')">
      <app-easy-textarea
        formControlName="descriptionOfStorage"
        [label]="TITLE + 'DESCRIPTION_OF_STORAGE' | translate"
        [rows]="3"
        [resizable]="false"
      ></app-easy-textarea>
    </mat-form-field>

    <ng-container *ngIf="!isSecondaryProductSheet">
      <app-optional-product-properties-subform
        groupName="optionalProperties"
        [readOnly]="readOnly"
      ></app-optional-product-properties-subform>
    </ng-container>

    <!--<fieldset>-->
    <app-easy-localized-seo-subform
      class="w-100"
      [formGroupAbstract]="form.get('seoProperties')!"
      [readOnly]="readOnly"
    ></app-easy-localized-seo-subform>

    <!--mat-form-field>
        <mat-label>
          {{ "SHARED.LOCALIZED_SEO_SUBFORM.META_TAGS" | translate }}
        </mat-label>
        <mat-chip-list #chipList [formControl]="metaInput">
          <mat-chip *ngFor="let tag of metaTags" (removed)="removeTag(tag)">
            {{ tag }}
            <button type="button" matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            [placeholder]="
              'SHARED.LOCALIZED_SEO_SUBFORM.META_TAGS_PLACEHOLDER' | translate
            "
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addTag($event)"
            [matChipInputAddOnBlur]="true"
          />
        </mat-chip-list>
        <mat-hint>{{ REQUIRED | translate }}</mat-hint>
        <mat-error *ngIf="getServerError('metaInput')">
          {{ getServerError("metaInput") }}
        </mat-error>
      </!--mat-form-field-->

    <!--</fieldset>-->

    <!-- end -->

    <div class="button-row" *ngIf="isCreateMode || isEditMode">
      <button
        type="button"
        mat-stroked-button
        color="primary"
        (click)="onCancel()"
      >
        <ng-container *ngIf="isCreateMode">
          {{ "SHARED.BACK" | translate | uppercase }}
        </ng-container>
        <ng-container *ngIf="isEditMode">
          {{ "SHARED.REJECT_CHANGES" | translate | uppercase }}
        </ng-container>
      </button>
      <button mat-raised-button color="primary" (click)="onSubmit()">
        <span *ngIf="isEditMode">
          {{ "SHARED.SAVE" | translate | uppercase }}
        </span>
        <span *ngIf="isCreateMode">
          {{ "SHARED.CREATE" | translate | uppercase }}
        </span>
      </button>
    </div>
    <ng-container *ngIf="isAdminMode && readOnly">
      <div class="button-row admin">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="changeProductStatus(contentStatus.Rejected)"
        >
          <mat-icon>close</mat-icon>
          {{ "SHARED.DECLINE" | translate }}
        </button>
        <div class="d-flex gap-4">
          <a
            *ngIf="isAdminMode && readOnly"
            mat-stroked-button
            color="primary"
            [routerLink]="['/admin/approvals/products/edit']"
            [queryParams]="{ id: form.value.packagingUnit?.id }"
            [routerLinkActive]="'active'"
          >
            <mat-icon>edit</mat-icon>
            {{ "SHARED.EDIT" | translate }}
          </a>
          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="changeProductStatus(contentStatus.Published)"
          >
            <mat-icon>checkmark</mat-icon>
            {{ "SHARED.APPROVE" | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <div class="button-row" *ngIf="!isAdminMode && readOnly">
      <button
        type="button"
        mat-stroked-button
        color="primary"
        (click)="onCancel()"
      >
        {{ "SHARED.BACK" | translate | uppercase }}
      </button>
    </div>
  </ng-container>
</form>
